export default [
  {
    path: '/main/system-modules',
    meta: {
      tag: 'list_systemmodule',
      name: 'Módulos',
      breadcrumb: 'Módulos'
    },
    component: () => import(/* webpackChunkName: "systemModules-list" */ '@/views/main/settings/users/systemModules/Index.vue'),
    children: [
      {
        path: '',
        name: 'listsystemmodules',
        meta: {
          tag: 'list_systemmodule',
          menu: 'settings',
          name: 'Módulos'
        },
        component: () => import(/* webpackChunkName: "systemModules-list" */ '@/views/main/settings/users/systemModules/List.vue')
      },
      {
        path: '/main/system-modules/add',
        name: 'addsystemmodule',
        meta: {
          tag: 'add_systemmodule',
          menu: 'settings',
          name: 'Adicionar | Módulo',
          breadcrumb: 'Adicionar Módulo'
        },
        component: () => import(/* webpackChunkName: "systemModules-add" */ '@/views/main/settings/users/systemModules/Add.vue')
      },
      {
        path: '/main/system-modules/:id',
        name: 'editsystemmodules',
        meta: {
          tag: 'edit_systemmodule',
          menu: 'settings',
          name: 'Editar | Módulos',
          breadcrumb: 'Editar Módulo'
        },
        component: () => import(/* webpackChunkName: "systemModules-edit" */ '@/views/main/settings/users/systemModules/Edit.vue')
      }
    ]
  }
]